import { AddIcon } from '@chakra-ui/icons';
import { IconButton } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

export function ButtonAdd() {
  const navigate = useNavigate();

  function onClick() {
    navigate('novo');
  }

  return (
    <IconButton
      aria-label="Add"
      icon={<AddIcon />}
      onClick={onClick}
      colorScheme="green"
      size="sm"
      borderRadius="full"
    />
  );
}
